import React from 'react';
import NiceModal, {useModal} from "@ebay/nice-modal-react";
import {modalClose} from "../genericFunctions";
import AssignConsumerToEquipment, {
    AssignConsumerToEquipmentProps
} from "../../../pages/consumers/equipment/components/Equipment/AssignConsumerToEquipment";
import SlideOver, {SlideOverProps} from "../../generic/SlideOver";


interface OwnProps extends SlideOverProps, AssignConsumerToEquipmentProps {
}

type Props = OwnProps;

// @ts-ignore
const AssignConsumerToEquipmentModal = NiceModal.create<Props>(({equipment, header, onClose}) => {
    const modal = useModal()

    const handleClose = (e) => {
        modalClose(e, modal, onClose)
    }

    return (
        <SlideOver title={header} onClose={handleClose} open={modal.visible} afterClose={modal.remove}>
            <AssignConsumerToEquipment equipment={equipment}/>
        </SlideOver>
    )
})

export default AssignConsumerToEquipmentModal;
